<template>
  <div class="container-fluid py-3 p-md-5 p-1">
    <div class="container-xxl">
      <div class="row align-items-center g-4">
        <!-- Gambar -->
        <div class="col-12 col-md-6 order-2 order-md-1">
          <div class="card border-0 bg-transparent text-center p-3 p-md-5">
            <img
              src="@/assets/welcome_img.webp"
              alt="Welcome"
              class="img-fluid rounded shadow-lg"
            />
          </div>
        </div>

        <!-- Teks / Konten -->
        <div
          class="col-12 col-md-6 order-1 py-5 px-4 px-md-0 pe-md-5 order-md-2 text-start"
        >
          <div class="fs-3 text-start text-md-start mb-3">
            Selamat Datang di Website
            <span class="fw-bold text-success fs-2">
              <br />GAHARU Outbound</span
            >
            👋
          </div>
          <p class="lead-welcome mb-4">
            Nikmati sensasi seru
            <span class="fw-bold text-success">Rafting</span> di arus deras,
            menjelajah alam dengan
            <span class="fw-bold text-success">Jeep Land Rover</span> dan
            <span class="fw-bold text-success">ATV</span>, hingga adu
            ketangkasan lewat
            <span class="fw-bold text-success">Paintball</span> dan
            <span class="fw-bold text-success">Flying fox</span>. Bersama
            pemandu profesional dan fasilitas terbaik, kami siap menghadirkan
            kegiatan <span class="fw-bold text-success">Team Building</span> dan
            <span class="fw-bold text-success">Fun Games</span> yang mempererat
            kerja sama dan menciptakan momen tak terlupakan.
          </p>
          <div class="div text-start">
            <a
              href="https://wa.me/6285802956931?text=Halo%20Gaharu%20Outbound%2C%20saya%20ingin%20konsultasi%20paket%20outbound"
              target="_blank"
              rel="noopener noreferrer"
              class="text-decoration-none"
              @click="handleWhatsAppClick"
            >
              <button class="btn btn-success fw-semibold wa-icon btn-animate-arrow">
                <i class="bi bi-whatsapp me-2"></i>
                <span class="fw-normal">Tanya Gratis & Konsultasi Paket</span>
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Tambahan opsional untuk tampilan */
img {
  max-width: 100%;
  height: auto;
}

.lead-welcome{
  font-size: 20px;
}

@media (max-width: 768px) {
  .container-fluid {
    padding: 2rem 1rem;
  }

  .lead-welcome {
  font-size: 15px;
  text-align: justify;
}
}

.wa-icon {
  /* width: 100px;   
  height: auto; */
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.wa-icon:hover {
  transform: translateY(-2px) scale(1.03);
  opacity: 0.95;
}

.btn-animate-arrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
</style>
